import { mergeProps as _mergeProps, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["checked", "disabled"]
const _hoisted_2 = { class: "flex flex-row items-center font-bold cursor-pointer text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("input", _mergeProps({ class: _ctx.classes }, _ctx.$attrs, {
      type: "checkbox",
      checked: _ctx.checked,
      disabled: _ctx.disabled,
      onInput: _cache[0] || (_cache[0] = (event) => _ctx.$emit('update:checked', event.target.checked))
    }), null, 16, _hoisted_1),
    _createElementVNode("label", _hoisted_2, _toDisplayString(_ctx.label), 1)
  ]))
}